import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Row, Col } from 'antd';

import FormLogin from './components/FormLogin';
import FormTitular from './components/FormTitular';
import FormAdminTitular from './components/FormAdminTitular';
import FormRepresentante from './components/FormRepresentante';
import InfoRepresentante from './components/InfoRepresentante';
import AdminInfoRepresentante from './components/AdminInfoRepresentante';
import ListaRepresentantes from './components/ListaRepresentantes';
import ListaAdminRepresentantes from './components/ListaAdminRepresentantes';
import ListaTitulares from './components/ListaTitulares';
import Header from './components/Header';
import Footer from './components/Footer';
import Comites from './components/Comites';
import FormAgregarComiteLogin from './components/FormAgregarComiteLogin';

import './App.css';

class App extends Component {

  render() {

    return (
      
      <BrowserRouter>
        <div>

          <Row>
            <Col span={24} style={{ textAlign:'center', margin:'10px 20px' }}>
              <Header />
            </Col>
          </Row>
          
          
          <br /><br />

              <Route exact path="/login/:comite/:num_comite" component={FormLogin} />
              <Route exact path="/registro/:comite/:num_comite" component={FormTitular} />  
              <Route exact path="/comite/:comite/:num_comite" component={FormAgregarComiteLogin} />  

              <Route exact path="/representante/:num_comite" component={ListaRepresentantes} />
              <Route exact path="/representante/:num_comite/registro" component={FormRepresentante} />
              <Route exact path="/representante/:num_comite/usuario/:usuario" component={InfoRepresentante} />

              <Route exact path="/admin" component={ListaTitulares} />
              <Route exact path="/admin/registro" component={FormAdminTitular} />
              <Route exact path="/admin/usuario/:usuario" component={AdminInfoRepresentante} />

              
           

          <Row>
            <Col span={24} style={{ textAlign:'center', margin:'10px 20px' }}>
              <Footer />
            </Col>
          </Row>

        </div>
      </BrowserRouter>
      
    );
  }
}
export default App;